import {TypeValuePair} from './type-value-pair';
import {FormType} from './form-data-tracking.model';

export class TransactionType {
  actionType?: string;
  adobeFormType?: FormType;
  code?: string;
  ctaLabel?: string;
  data?: TypeValuePair[];
  displayInHeroSection?: boolean;
  displayInPublisherSection?: boolean;
  isLoginRequired?: boolean;
  isFullRegistrationRequired?: boolean;
  showMessageTaxAndDiscount?: boolean;
  isZeroPriceAllowed?: boolean;
  shouldPrefillCartFromContract?: boolean;
  shouldFilterEntitlements?: boolean;
  signNewTermsConditionsWithContract?: boolean;
  pageId?: string;
}
